import api from './axios';

/** Branch offices (spec §13.2). */
export const listBranches  = (params = {})       => api.get('/v1/branches', { params });
export const createBranch  = (payload)           => api.post('/v1/branches', payload);
export const updateBranch  = (branchId, payload) => api.put(`/v1/branches/${branchId}`, payload);
export const deleteBranch  = (branchId)          => api.delete(`/v1/branches/${branchId}`);

/**
 * Queues a directory CSV (Rule 66) and returns a history row to poll.
 */
export const createBranchExport = (filters = {}) => api.post('/v1/branch-exports', filters, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

export const getBranchExport = (exportId) => api.get(`/v1/branch-exports/${exportId}`);
